import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";
import moment from "moment";
const TTFTraineeDetails = (props) => {
  const [data, setData] = useState([]);
  const [index, setIndex] = useState(0);

  const value = useSelector((state) => state.viewDetails);

  useEffect(async () => {
    let result = await props.data.map((item) => {
      return {
        ...item,
        TTFdate: item.TTFDate
          ? moment(new Date(item.TTFDate)).format("YYYY-MM-DD")
          : "",
      };
    });
    setData(result);
  }, [props]);

  useEffect(() => {
    setIndex(value.index);
  }, [value]);

  return (
    <>
      {data.length > 0 ? (
        <div>
          <Grid className="p-10px" container spacing={2}>
            <Grid item xs={12} container>
              <Grid item xs={3}>
                TTF Status :
              </Grid>
              <Grid item xs={9}>
                {data[index].TTFStatus}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                Attended TTF :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].AttendedTTF != null
                  ? data[index].AttendedTTF === true
                    ? "Yes"
                    : "No"
                  : null}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TTF/Training Date and Time :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TTFdate} {data[index].TTFTime}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TTF Zoom Link:
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TTFZoomLink}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TTF Zoom PW :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TTFZoomPassword}
              </Grid>
            </Grid>
          </Grid>
        </div>
      ) : null}
    </>
  );
};

export default TTFTraineeDetails;
